import { createSelector } from 'reselect';
import { ROLES } from '@config/authentication';

export const selectAdmin = (state) => state.admin;
export const selectUsers = (state) => selectAdmin(state).users.data;
export const selectVisibleUsers = createSelector(
  selectUsers,
  (users) =>
    users.filter(({ role }) =>
      [ROLES.SUPER_ADMIN, ROLES.ANALYST, ROLES.ATTENDEE].includes(role),
    ),
);
export const selectAssignableUsers = createSelector(
  selectVisibleUsers,
  (users) =>
    users
      .filter(({ role }) => [ROLES.SUPER_ADMIN, ROLES.ANALYST].includes(role))
      .map(({ id, username, email }) => ({
        value: String(id),
        label: username || email,
      })),
);

export const selectCreateUser = (state) => selectAdmin(state).createUser;
export const selectCreateUserForm = (state) => selectAdmin(state).createUserForm;

export const selectEditUser = (state) => selectAdmin(state).editUser;
export const selectPermissionsForm = (state) => selectAdmin(state).editUserForm;
export const selectPermissionsFormUserId = (state) => selectPermissionsForm(state).userId;
// FIXME: #649 Replace this selectors names with something more meaningful
export const selectPermissionsFormSelectedPermission = (state) =>
  selectPermissionsForm(state).selectedPermission;

export const isLoadingUsers = (state) => selectAdmin(state).users.loading;
export const isCreatingUser = (state) => selectCreateUser(state).loading;

export const isSavingUserPermission = (state) => selectEditUser(state).loading;
export const isPermissionFormVisible = (state) =>
  selectPermissionsFormUserId(state) !== null;

export const selectUser = (state, userId) =>
  selectUsers(state).find((user) => user.id === userId);

export const selectCurrentUserPermission = (state, userId) =>
  selectUser(state, userId).role;

export const selectSettings = (state) => selectAdmin(state).settings;



// WEBPACK FOOTER //
// ./redux/selectors/admin.js